import BaseModel from '../core/BaseModel'
export default class ProductSerialNumberModel extends BaseModel {
    constructor() {
        super({ 
                name: "production_order",
                tableName: 'core_production_order'
            }, 
            {
            id : { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            created_date: { 
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Thời gian tạo',
                sortable: true,
                width: 15,
                filter: { type: 'DateRange', match: 'custom'}
            },
            production_order_code: { 
                name: 'production_order_code', 
                type: "String", 
                label: 'Lệnh sản xuất',
                class: 'center',
                sortable: true,
                width: 14,
                filter: { type: 'input', match: 'custom'}
            },
            manufacturing_date: { 
                name: 'manufacturing_date', 
                type: "CustomDateTime", 
                label: 'Ngày sản xuất',
                sortable: true,
                width: 15,
                filter: { type: 'DateRange', match: 'custom'}
            },
            model_code: { 
                name: 'model_code', 
                type: "String", 
                label: 'Model sản phẩm',
                width: 15,
                filter: { type: 'input', match: 'custom'},
                sortable: true,
                computed: (data) => {
                    data.model_code = (data.product != undefined && data.product != null) ? data.product.model_code : ''
                }
            },
            model_name: { 
                name: 'model_name', 
                type: "String", 
                label: 'Tên sản phẩm',
                width: 15,
                filter: { type: 'input', match: 'custom'},
                sortable: true,
                computed: (data) => {
                    data.model_name = (data.product != undefined && data.product != null) ? data.product.name : ''
                }
            },
            amount: { 
                name: 'amount', 
                type: "String", 
                label: 'Số lượng',
                class: 'center',
                width: 10,
                sortable: true
            },
            author_name: { 
                name: 'author_name', 
                type: "String", 
                label: 'Người tạo',
                width: 15,
                filter: { type: 'input', match: 'custom'},
                sortable: true,
                class: 'center',
                computed: (data) => {
                    data.author_name = (data.users != undefined && data.users != null) ? data.users.full_name : ''
                }
            },
            status: { 
                name: 'status', 
                type: "Selection",
                label: 'Trạng thái',
                dataType: 'Label',
                class: 'center',
                width: 10,
                options: [{ value: 1, label: 'Hoàn thành', style: 'color: #00CC00; font-weight: 500;'}, { value: 0, label: 'Mới', style: 'color: #FF0000; font-weight: 500;'}, { value: 2, label: 'Huỷ', style: 'color: #333; font-weight: 500;'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                sortable: true
            },
            product_id: {
                refs: ' product { model_code name} users { full_name } product_serial_number { created_date }',
                display: false
            }
        },)
    }

}